import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/binomial-tree-calculator',
  component: () => import('../../routes/BinomialTreeCalculator.svelte'),
  card: {
    id: 'binomial-tree-calculator',
    title: 'Binomial Tree Option Pricing',
    description: 'Price European and American options using the Cox-Ross-Rubinstein binomial tree model with Greeks and convergence analysis.',
    icon: 'account_tree',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/binomial-tree-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Binomial Tree Option Pricing Calculator – CRR Model for European & American Options',
    description: 'Free binomial tree option pricing calculator using the Cox-Ross-Rubinstein model. Price European and American (Bostian) options with Greeks, convergence analysis, and adjustable tree steps.',
  },
};

export default meta;
